
import UsersDdown from './users-ddown.vue'

export default {
  components: {UsersDdown},
  props: {
    tenant: {type: Object, required: true}
  },
  emits: ['submit'],
  data() {
    return {
      user: undefined,
      user_id: undefined,
      is_superuser: false,
      is_beta: false,
      is_tenant_manager: false,
    }
  },
  computed: {
    can_submit() {
      return !!this.user_id
    }
  },
  watch: {
    user: function(val) {
      this.is_superuser = val?.raw.is_admin
      this.is_beta = val?.raw.is_beta
      this.is_tenant_manager = val?.raw.is_tenant_manager
    }
  },
  methods: {
    open(){
      this.user = undefined
      this.user_id = undefined
      this.is_superuser = false
      this.is_beta = false
      this.is_tenant_manager = false

      this.$refs.modal.open()
    },
    close() {
      this.$refs.modal.close()
    },
    submit() {
      this.close()
      this.$emit('submit', this.user_id, {
        is_superuser: this.is_superuser,
        is_beta: this.is_beta,
        is_tenant_manager: this.is_tenant_manager,
      })
    }
  }
}
